import React, { Component } from 'react';
import TextField from '@mui/material/TextField';

export default class CodProdInput extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: props.value || '00000',
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ value: this.props.value || '00000' });
        }
    }

    handleChange = (event) => {
        const inputValue = event.target.value;
        const apenasNumeros = inputValue.replace(/\D/g, '');
        const valorLimitado = apenasNumeros.slice(-5);
        const valorFormatado = valorLimitado.padStart(5, '0');
        this.setState({ value: valorFormatado });
        if (this.props.onChange) {
            this.props.onChange(valorFormatado);
        }
    };

    handleFocus = (event) => {
        if (this.state.value === '') {
            this.setState({ value: '00000' });
        }
    };

    render() {
        return (
            <TextField
                {...this.props.props}
                inputProps={{ min: 0, max: 99999 }}
                sx={this.props.sx}
                error={this.props.error === true}
                helperText={this.props.error === true ? "Informe o código" : null}
                size="small"
                variant="outlined"
                name="numemp"
                label={'Cód. Prod.' + (this.props.required ? '*' : '')}
                value={this.state.value}
                onChange={this.handleChange}
                onFocus={this.handleFocus}
            />
        );
    }
}